import { useContext } from 'react'

import SubmissionListFilterProvider, { SubmissionListFilterContext } from './Provider'

export { SubmissionListFilterProvider, SubmissionListFilterContext }
export type { ISubmissionListFilterContextProps } from './Provider'

export const useSubmissionListFilter = () => useContext(SubmissionListFilterContext)
